import { Card as MuiCard } from "@mui/material";


export const Card = (props: any) => {
    return<MuiCard {...props}>
        </MuiCard>
  };
